var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueSlickCarousel',_vm._b({ref:"carousel",staticClass:"carousel"},'VueSlickCarousel',_vm.settings,false),_vm._l((_vm.pictures),function(picture,index){return _c('img',{key:index,staticClass:"w-600",attrs:{"src":picture,"draggable":"false"}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }